// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "common" + "." + "737e5b6e9712901f763f" + ".css";
};